<template>
  <a-layout class="index animated fadeIn">
    <a-card :bordered="false">
      <a-tabs v-model:activeKey="activeKey">
        <a-tab-pane key="1" tab="品牌商收支明细">
          <brandList></brandList>
        </a-tab-pane>
        <a-tab-pane key="2" tab="品牌商收支统计">
          <statistics></statistics>
        </a-tab-pane>
        <a-tab-pane key="3" tab="代发红包明细">
          <redPacket></redPacket>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>
<script>
import { onMounted, inject, reactive, toRefs ,ref} from "vue";
import statistics from "./statistics";
import brandList from "./components/brandList";
import redPacket from "./components/redPacket";
export default {
  components: { brandList ,statistics,redPacket},
  setup(props) {
    const $route = inject("$route");
    const $Modal = inject("$Modal");
    const state = reactive({
      activeKey: ref($route.query.type),
    });
    onMounted(() => {});
    return {
      ...toRefs(state),
    };
  },
};
</script>
